module.exports = __webpack_public_path__ + "img/30.b64b0c22.png";